import React from 'react';
import { ROUTES } from '../../const';
import { I18n } from 'react-redux-i18n-lite';
import { getConfigurationFromStorage } from '../../shared';

export default class Footer extends React.Component {
  render() {
    const config = getConfigurationFromStorage() ? JSON.parse(getConfigurationFromStorage()) : null;

    return (
      <div className={'login-footer-parent'}>
        <a href={'https://sarelaeditorial.com/'} target={'_blank'} className={'login-footer-link'}>
          {I18n.t('login.developedBy')}
        </a>
        <div className={'login-footer-separator'}>|</div>
        <a
          href={config && config.legalNoticeUrl ? config.legalNoticeUrl : 'https://sarelaeditorial.com/aviso-legal/'}
          target={'_blank'}
          className={'login-footer-link'}
        >
          {I18n.t('login.legalWarning')}
        </a>
        <div className={'login-footer-separator'}>|</div>
        <a
          href={
            config && config.privacyPolicyUrl ? config.privacyPolicyUrl : 'https://sarelaeditorial.com/politica-privacidad/'
          }
          target={'_blank'}
          className={'login-footer-link'}
        >
          {I18n.t('login.privacyPolicy')}
        </a>
        <div className={'login-footer-separator'}>|</div>
        <a href={ROUTES.COOKIES_DETAIL} target={'_blank'} className={'login-footer-link'}>
          {I18n.t('login.cookies')}
        </a>
      </div>
    );
  }
}
